import React, { useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

export function NotFound() {
  const [show, setShow] = React.useState(false);
  useEffect(() => {
    const handle = setTimeout(() => {
      setShow(true);
    }, 100);
    return () => {
      clearTimeout(handle);
    };
  }, []);
  return show ? (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <Box sx={{ marginBottom: '2rem' }}>
        <CircularProgress color="secondary" size="3rem" />
      </Box>
      <Typography variant="h4" color="secondary">
        Preparing your property dashboard...
      </Typography>
    </Box>
  ) : null;
}
